import { useContext, useEffect } from 'react';

import type { IGlobalBreadcrumbs } from '@shared/context/GlobalBreadcrumbsContextWrapper';
import { GlobalBreadcrumbsContext } from '@shared/context/GlobalBreadcrumbsContextWrapper';

interface UseGlobalBreadcrumbsParams extends IGlobalBreadcrumbs {
  skip?: boolean;
}

const useGlobalBreadcrumbs = (globalBreadcrumbsParams: UseGlobalBreadcrumbsParams) => {
  const { setGlobalBreadcrumbs } = useContext(GlobalBreadcrumbsContext)!;

  useEffect(() => {
    if (!globalBreadcrumbsParams.skip) {
      setGlobalBreadcrumbs(globalBreadcrumbsParams);
    }

    return () => {
      setGlobalBreadcrumbs(undefined);
    };
  }, [globalBreadcrumbsParams, setGlobalBreadcrumbs]);
};

export default useGlobalBreadcrumbs;
